var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
import { failureHash } from "./edit.static";
export class ApiSmpGptEdit {
}
_a = ApiSmpGptEdit;
ApiSmpGptEdit.modidyImage = ({ image, prompt }, signal) => __awaiter(void 0, void 0, void 0, function* () {
    const fd = new FormData();
    fd.append("image", image);
    fd.append("prompt", String(prompt));
    const resp = yield apiRequest({
        body: fd,
        endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/edit",
        method: "POST",
        signal,
    }, failureHash);
    if (resp.ok) {
        return resp.blob();
    }
    throw new Error(resp.statusText);
});
//# sourceMappingURL=edit.js.map